/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
import { useContext, useEffect, useRef, useState } from "react";
import { api } from "../../config/api";
import { logEvent } from "../../services/eventLog";
import { Project } from "../../config/models";
import styles from "./costProjectsPage.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import SelectProjectModal from "../../components/modal/selectProject/SelectProjectModal";
import _ from "lodash";
import { CircularProgress, Dialog } from "@material-ui/core";
import CreateProjectModal from "../../components/modal/createProject/CreateProject";
import { util } from "../../config/util";
import { Cookies } from "../../constants/Cookies";
import { useHistory } from "react-router-dom";
import { pages } from "../../constants/PagePaths";
import AlertContext from "../../contexts/AlertContext";
import { LoadingContext } from "../../contexts/LoadingContext";
import * as crypto from "crypto-js";
import SimpleConfirm from "../../components/modal/confirm/SimpleConfirm";
import DupLoginContext from "../../contexts/DupLoginContext";
import { useLocation } from "react-router-dom";
import { FreeUseDay } from "../../constants/General";
import { Link } from "react-router-dom";
import WorkListModal from "../../components/modal/workListModal/WorkListModal";
import WorkListModifyModal from "../../components/modal/workListModifyModal/WorkListModifyModal";
import DeleteConfirm from "../../components/modal/deleteConfirm/DeleteConfirm";
import EditProjectInfo from "../../components/modal/editProjectInfo/EditProjectInfo";
import EditProject from "../../components/modal/editProject/EditProject";
import { isCustomEstimateTester } from "../../constants/CustomEstimate";

/** 중복 로그인 안내를 이미 띄웠다는 표시 — 같은 실패로 알림을 두 번 띄우지 않는다. */
const DUP_LOGIN = "__dup_login__";
/** 서버 호출 결과가 성공인가. checkDupLogin 은 401 이 아닌 실패를 알림 없이 err.response 로 돌려주므로 반드시 이걸로 본다.
 *  서버 응답은 {code: 1} 이 성공이고 0·-1 은 실패(message 에 이유). */
const isOk = (res: any): boolean =>
  !!res && res.status === 200 && (res.data?.code === undefined || res.data.code === 1);
const failMsg = (res: any, fallback: string): string =>
  (res?.data?.message as string) || (res ? `${fallback} (오류 ${res.status})` : `${fallback} 서버와 연결을 확인해 주세요.`);

export default (props: any) => {
  const pageSize = 8;
  const [workProjects, setWorkProjects] = useState<[]>([]);
  const [originProjects, setOriginProjects] = useState<Project[]>();
  const [originWorkLists, setoriginWorkLists] = useState<Project[]>();
  const [projects, setProjects] = useState<Project[]>();
  const [currentIndex, setCurrentIndex] = useState(1);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(pageSize);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchFilterValue, setSearchFilterValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false); // 오른쪽 ⋮ 메뉴(.xml 파일열기 등 드물게 쓰는 기능)
  const moreRef = useRef<HTMLDivElement>(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [estimate, setEstimate] = useState(false);
  const [copy, setCopy] = useState(false);
  const [tempRow, setTempRow] = useState(false);
  const [removeConfirmOpen, setRemoveConfirmOpen] = useState(false);
  const [editConfirmOpen, setEditConfirmOpen] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(0);
  const [isModalType, setIsModalType] = useState(0);
  const [isWorkModalState, setIsWorkModalState] = useState(false);
  const [isWorkModalModifyState, setIsWorkModalModifyState] = useState(false);
  const [isWorkModalModifyItem, setIsWorkModalModifyItem] = useState({});

  const isExpiredUser = useRef(false);
  // 타 프로그램 불러오기·엑셀 변환은 설계내역 이용권(STATEMENT, 체험 포함)이 살아 있을 때만. 서버(import_views)도 같은 기준으로 막는다.
  const hasStatementPass = useRef(false);
  const [tutorialLoading, setTutorialLoading] = useState(false);
  const [showTutorialChoice, setShowTutorialChoice] = useState(false);

  const alert = useContext(AlertContext);
  const dupLogin = useContext(DupLoginContext);
  const loadingCtx = useContext(LoadingContext);
  // 파일 불러오기·변환처럼 오래 걸리는 작업: 무엇을 하는 중인지와 경과 시간을 계속 보여준다.
  // (이 화면의 loading 상태는 그려지지 않아, 큰 파일을 고르면 몇 분 동안 아무 반응이 없어 보였다 — 10-26)
  const busyTimer = useRef<number | null>(null);
  const startBusy = (first: string) => {
    const started = Date.now();
    let stage = first;
    const render = () => {
      const sec = Math.floor((Date.now() - started) / 1000);
      const t = sec < 60 ? `${sec}초` : `${Math.floor(sec / 60)}분 ${sec % 60}초`;
      const slow = sec >= 20 ? "\n\n파일이 커서 시간이 걸리고 있습니다.\n창을 닫지 말고 기다려 주세요." : "";
      // 경과 시간은 3초 넘게 걸릴 때부터 — 뜨자마자 '(경과 0초)' 가 보이면 어색하다
      loadingCtx.showLoading(sec >= 3 ? `${stage}\n(경과 ${t})${slow}` : stage);
    };
    if (busyTimer.current) window.clearInterval(busyTimer.current);
    render();
    busyTimer.current = window.setInterval(render, 1000);
    return {
      stage: (m: string) => { stage = m; render(); },
      done: () => {
        if (busyTimer.current) window.clearInterval(busyTimer.current);
        busyTimer.current = null;
        loadingCtx.closeLoading();
      },
    };
  };
  useEffect(() => () => { if (busyTimer.current) window.clearInterval(busyTimer.current); }, []);
  // 화면에 안내 문구를 그릴 틈을 준다(바로 뒤에 브라우저를 오래 붙잡는 복호화가 오면 문구가 안 보인다)
  const paint = () => new Promise((r) => setTimeout(r, 60));
  const mb = (n: number) => (n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)}MB` : `${Math.max(1, Math.round(n / 1024))}KB`);
  const history = useHistory();
  const location = useLocation();
  const windowLocation = window.location.href;
  const paths = windowLocation.split("/");
  let lastpath = paths[paths.length - 1];
  const [type, setType] = useState(lastpath);

  const handleChange = (page: number) => {
    setCurrentIndex(page);
    setMinIndex((page - 1) * pageSize);
    setMaxIndex(page * pageSize);
  };

  const showWorkListModal = (type: any) => {
    setIsWorkModalState(true);
    setIsModalType(type);
  };

  const setModifyState = (item?: any) => {
    setIsWorkModalState(false);
    setIsWorkModalModifyState(true);
    setIsWorkModalModifyItem(item);
  };
  const onWorkListSave = () => {};
  // 시작 화면(/welcome)에서 '설계내역 만들러 왔어요'를 고르고 왔으면 튜토리얼 선택을 펼쳐 둔다(1회)
  useEffect(() => {
    try {
      if (window.sessionStorage.getItem("conax_open_tutorial")) {
        window.sessionStorage.removeItem("conax_open_tutorial");
        setShowTutorialChoice(true);
      }
    } catch (e) {
      // 무시
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    const windowLocation = window.location.href;
    const paths = windowLocation.split("/");
    lastpath = paths[paths.length - 1];
    if (lastpath == "copy") {
      setCopy(true);
    } else {
      setCopy(false);
    }
    setType(lastpath);
    new Promise(async () => {
      const key = util.getCookie(Cookies.authKey);
      if (!key) {
        alert.showAlert(
          "로그인 후 이용해주세요.\n회원가입시 " +
            FreeUseDay +
            "일 무료기간 제공중입니다.",
          () => {
            history.push(pages.login);
          }
        );
        return;
      } else {
        const info = await dupLogin.checkDupLogin(api.getMyInfo);
        if (
          info?.data?.expiry_date?.toString() === "None" ||
          new Date(info?.data?.expiry_date).getTime() -
            new Date(new Date().format("yyyy-MM-dd")).getTime() <
            0
        ) {
          isExpiredUser.current = true;
        }
        const today = new Date();
        hasStatementPass.current = (info?.data?.expiry_dates || []).some(
          (e: any) => e?.name === "STATEMENT" && e?.expiry_date && today <= new Date(e.expiry_date)
        );
        // 커스텀 견적서(베타): 접근 명단만 — URL 직접 진입 차단 (dk-cost 가드와 동일 기준).
        // 판정은 **서버**가 준다(user/info 의 is_custom_estimate_tester). 이메일만 넘기면
        // 어드민 명단에 등록해도 이 화면에서 계속 막힌다 — 실제로 그 상태였다.
        if (
          lastpath === "custom_estimate" &&
          !isCustomEstimateTester(
            info?.data?.email,
            info?.data?.is_custom_estimate_tester
          )
        ) {
          alert.showAlert(
            "커스텀 견적서는 현재 내부 테스트 중입니다.",
            () => history.push(pages.index)
          );
          return;
        }
      }
      await getProjects();

      setLoading(false);
    });
  }, [location]);

  const onClose = async () => {
    setDialogOpen(false);
    await getProjects();
  };

  const search = (value: string, filter?: string) => {
    let ps: any;
    if (lastpath != "worklist") {
      ps = originProjects?.filter((element: any) => {
        if (filter != "") {
          if (filter == "normal") {
            return element.name.includes(value) && element.subTypes[0] == null;
          }
          return (
            element.name.includes(value) && element.subTypes.includes(filter)
          );
        }
        return element.name.includes(value);
      });
      setSearchValue(value);
      setProjects(ps);
      setCurrentIndex(1);
      setMinIndex(0);
      setMaxIndex(pageSize);
      setSelectedIndex(0);
    } else {
      ps =
        value === "" || !value
          ? _.cloneDeep(originWorkLists)
          : originWorkLists?.filter((element: any) => {
              return element.constructionName?.includes(value);
            });
      setSearchValue(value);
      setWorkProjects(ps);
    }
  };

  const startTutorial = async (template: "일반" | "건축") => {
    if (isExpiredUser.current) {
      logEvent("paywall_shown", "tutorial", { template, project_count: originProjects?.length ?? null });
      alert.showAlert("이용권을 구매하셔야 튜토리얼을 시작할 수 있습니다.");
      return;
    }
    setShowTutorialChoice(false);
    setTutorialLoading(true);
    try {
      const title = template === "건축" ? "튜토리얼 - 건축공사" : "튜토리얼 - 건설공사";
      const res: any = await dupLogin.checkDupLogin(() =>
        api.createProject(title, false, false, false, "", "", template)
      );
      const projectId = res?.data?.id || res?.data?.project?.id;
      if (!projectId) {
        alert.showAlert("프로젝트 생성에 실패했습니다.");
        setTutorialLoading(false);
        return;
      }
      const costUrl = process.env.REACT_APP_COST_URL || "http://localhost:4200/";
      window.location.href = `${costUrl}document/${window.btoa(String(projectId))}?tutorial=landscape`;
    } catch (e: any) {
      console.error("Tutorial project creation failed:", e);
      alert.showAlert("프로젝트 생성에 실패했습니다. 다시 시도해주세요.");
      setTutorialLoading(false);
    }
  };

  const createProject = () => {
    if (
      isExpiredUser.current &&
      (originProjects?.length == null || originProjects.length > 0)
    ) {
      logEvent("paywall_shown", "create_project", { project_count: originProjects?.length ?? null });
      alert.showAlert("이용권을 구매하셔야 프로젝트 추가 생성이 가능합니다.");
      return;
    }

    setSelectedProjectId(-1);
    setEditConfirmOpen(true);
    setTempRow(false);
    setCreateOpen(true);
    setEstimate(false);
    setCopy(false);
  };

  const createClose = async (
    title?: string,
    varCopy?: boolean,
    varEestimate?: boolean,
    tempRow?: boolean
  ) => {
    setCreateOpen(false);
    if (!title) return;
    setLoading(true);
    // 커스텀 견적서: 이름으로 문서+프로젝트를 만들고 바로 편집기로 (기존 견적서와 동일한 생성 UX)
    if (type == "custom_estimate") {
      try {
        const res: any = await api.createCustomEstimateDoc(title);
        const projectId = res?.data?.result?.project_id;
        if (projectId) {
          window.location.href = `${
            process.env.REACT_APP_COST_URL
          }custom-estimate/${window.btoa(String(projectId))}`;
          return;
        }
      } catch (e) {
        alert.showAlert("커스텀 견적서 생성에 실패했습니다.");
      }
      await getProjects();
      setLoading(false);
      return;
    }
    let isCopy: boolean = false;
    let isEstimate: boolean = false;
    if (type == "copy") {
      isCopy = true;
    } else if (type == "estimate") {
      isEstimate = true;
    }
    const busy = startBusy("프로젝트를 만드는 중입니다");
    try {
      const res: any = await api.createProject(title, tempRow ? true : false, isEstimate, isCopy);
      if (!isOk(res)) throw new Error(failMsg(res, "프로젝트를 만들지 못했습니다."));
      await getProjects();
    } catch (error: any) {
      alert.showAlert(error?.response ? failMsg(error.response, "프로젝트를 만들지 못했습니다.") : (error?.message || "프로젝트를 만들지 못했습니다."));
    } finally {
      busy.done();
      setLoading(false);
    }
  };

  const createEstimateProject = () => {
    if (
      isExpiredUser.current &&
      (originProjects?.length == null || originProjects.length > 0)
    ) {
      logEvent("paywall_shown", "create_estimate", { project_count: originProjects?.length ?? null });
      alert.showAlert("이용권을 구매하셔야 프로젝트 추가 생성이 가능합니다.");
      return;
    }
    setCreateOpen(true);
    setEstimate(true);
    setTempRow(true);
    setCopy(false);
  };

  const createCopyProject = () => {
    if (
      isExpiredUser.current &&
      (originProjects?.length == null || originProjects.length > 0)
    ) {
      logEvent("paywall_shown", "create_copy", { project_count: originProjects?.length ?? null });
      alert.showAlert("이용권을 구매하셔야 프로젝트 추가 생성이 가능합니다.");
      return;
    }
    setEstimate(false);
    setCopy(true);
    setTempRow(true);
    setCreateOpen(true);
  };

  const clickProject = (project: any) => {
    const type = project.type;
    const id = project.id;
    if (type === "custom_estimate") {
      // 커스텀 견적서: 문서는 dk-cost 커스텀 견적 편집기에서 (프로젝트 id 딥링크)
      const url = `${
        process.env.REACT_APP_COST_URL
      }custom-estimate/${window.btoa(String(id))}`;
      window.location.href = url;
    } else if (type === "estimate") {
      const url = `${process.env.REACT_APP_COST_URL}document/${window.btoa(
        id
      )}`;
      window.location.href = url;
    } else {
      history.push(pages.costprojects + "/detail/" + id + "?type=" + type);
      // setDialogOpen(true);
      // setSelectedIndex(project.id);
    }
  };

  const clickFile = () => {
    if (isExpiredUser.current) {
      logEvent("paywall_shown", "import_conax", { project_count: originProjects?.length ?? null });
      alert.showAlert("이용권을 구매하셔야 프로젝트 추가 생성이 가능합니다.");
      return;
    }
    document.getElementById("conaxFile")?.click();
  };

  // ⋮ 메뉴 바깥을 누르면 닫는다
  useEffect(() => {
    if (!moreOpen) return;
    const onDown = (e: MouseEvent) => {
      if (moreRef.current && !moreRef.current.contains(e.target as Node)) setMoreOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [moreOpen]);

  // 타 프로그램(나스 SGS·다산 EST·글로텍 EBS·이지테크·하우코스트 XCost·아성) 파일 → 콘엑스 양식 엑셀로 변환해 내려받기
  const clickConvertFile = () => {
    if (!hasStatementPass.current) {
      logEvent("paywall_shown", "convert_other", { project_count: originProjects?.length ?? null });
      alert.showAlert("설계내역 이용권이 있어야 엑셀로 변환할 수 있습니다.");
      return;
    }
    document.getElementById("convertFile")?.click();
  };

  const changeConvertFile = async (event: any) => {
    const file: File | undefined = event.target.files?.[0];
    event.target.value = ""; // 같은 파일을 다시 고를 수 있게
    if (!file) return;
    if (!/\.(sgs|est|estx|ebs|kdbx|xct|asgs|zip)$/i.test(file.name)) {
      alert.showAlert(".sgs, .est, .estx, .ebs, .kdbx, .xct, .asgs, .zip 파일만 변환할 수 있습니다.");
      return;
    }
    const busy = startBusy(`콘엑스 양식 엑셀로 변환하는 중입니다 (${mb(file.size)})`);
    try {
      const { blob, filename } = await api.convertEstimationToExcel(file);
      busy.done();
      // 변환이 1~2분 걸리면 파일 선택 클릭의 사용자 동작이 만료돼 크롬이 '자동 다운로드'로 막는다
      // (같은 페이지 두 번째부터). 확인 버튼 클릭 안에서 내려받기를 시작한다.
      let saved = false; // 알림 창은 확인·닫기 처리 둘 다 콜백을 부를 수 있어 한 번만 내려받는다
      const save = () => {
        if (saved) return;
        saved = true;
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      };
      alert.showAlert(`콘엑스 양식 엑셀로 변환했습니다.\n확인을 누르면 내려받습니다: ${filename}`, save);
    } catch (error: any) {
      busy.done();
      alert.showAlert(error?.message || "파일을 변환하지 못했습니다. 파일을 다시한번 확인해 주세요.");
    } finally {
      busy.done();
    }
  };

  // '타 프로그램' 버튼 → 선택창(불러오기 / 콘엑스 양식 엑셀 변환)
  const [otherOpen, setOtherOpen] = useState(false);
  // 서버가 불러오기를 되물은 상태(수량 없는 자료집 / 46MB 초과). 파일은 서버가 20분 보관(uploadToken)해 다시 올리지 않는다.
  type ImportAsk = {
    reason: "no_quantity" | "too_large" | "token_expired";
    message: string;
    hasQuantity: boolean;
    counts: { itemize_costs?: number; price_calculations?: number; materials?: number; labors?: number; machines?: number };
    limitMb?: number;
    uploadToken: string;
    fileName: string;
  };
  const [importAsk, setImportAsk] = useState<ImportAsk | null>(null);
  // '단가집으로 올리기' 창: 미리보기(담길 개수·내 단가집 목록) → 이름/기존 단가집 선택 → 저장
  const [libDlg, setLibDlg] = useState<{
    uploadToken: string;
    fileName: string;
    preview: any;
    name: string;
    target: "new" | "existing";
    libraryId: string;
  } | null>(null);
  const [libSaving, setLibSaving] = useState(false);
  const countsLine = (c: ImportAsk["counts"] | undefined) =>
    c
      ? [
          ["일위대가", c.itemize_costs],
          ["단가산출", c.price_calculations],
          ["자재", c.materials],
          ["노임", c.labors],
        ]
          .filter(([, n]) => (n as number) > 0)
          .map(([k, n]) => `${k} ${(n as number).toLocaleString()}`)
          .join(" · ")
      : "";
  const otherProgramButton = (
    <button type="button" className="btn btn-light left-icon" onClick={() => setOtherOpen(true)}>
      <span className="material-symbols-outlined me-2">swap_horiz</span>
      타 프로그램
    </button>
  );
  const clickOtherImport = () => {
    if (!hasStatementPass.current) {
      logEvent("paywall_shown", "import_other", { project_count: originProjects?.length ?? null });
      alert.showAlert("설계내역 이용권이 있어야 타 프로그램 파일을 불러올 수 있습니다.");
      return;
    }
    document.getElementById("otherFile")?.click();
  };

  const clickImportXmlFile = () => {
    if (isExpiredUser.current) {
      logEvent("paywall_shown", "import_xml", { project_count: originProjects?.length ?? null });
      alert.showAlert("이용권을 구매하셔야 프로젝트 추가 생성이 가능합니다.");
      return;
    }
    document.getElementById("xmlFile")?.click();
  };

  const getProjects = async () => {
    if (lastpath == "worklist") {
      const workObj: any = await api.getWorklists({ offset: 0, limit: 40 });
      const workProjects = workObj?.data.worklist_list;
      setWorkProjects(workProjects);
      setoriginWorkLists(workProjects);
    } else {
      const windowLocation = window.location.href;
      const paths = windowLocation.split("/");
      const tt = paths[paths.length - 1];
      let projects: any;
      try {
        projects = await api.getProjects(tt);
      } catch (error: any) {
        // 목록을 못 받으면 빈 목록처럼 보이지 않게 알린다(401 은 checkUser 쪽 중복 로그인 안내가 처리)
        if (error?.response?.status !== 401) {
          alert.showAlert("프로젝트 목록을 불러오지 못했습니다.\n잠시 뒤 새로고침해 주세요.");
        }
        return;
      }
      setOriginProjects(projects);
      setProjects(projects);
    }
  };

  const clickDelete = async (event: any, id: number) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedProjectId(id);
    setRemoveConfirmOpen(true);
  };
  const handleWorklistDelete = (event: any, id: number) => {
    event.stopPropagation();
    event.preventDefault();
    alert.showConfirmAlert(
      "알림",
      "공사 목록을 삭제하시겠습니까?",
      "예",
      "아니오",
      async () => {
        await api.deleteWorklist(id);
        const index = workProjects?.findIndex(
          (element: any) => element.worklist_id === id
        );
        const cloneWorklists = _.cloneDeep(workProjects);
        cloneWorklists?.splice(index, 1);
        setWorkProjects(cloneWorklists);
      }
    );
  };

  const clickEdit = async (event: any, id: number) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedProjectId(id);
    const project = projects?.find((p) => p.id === id);
    alert.showPrompt(
      "프로젝트 이름을 입력해주세요.",
      project?.name,
      async (value) => {
        if (value != undefined && project) {
          const prevName = project.name;
          project.name = value;
          const res = await dupLogin.checkDupLogin(() => api.editProjectInfo(project));
          if (!isOk(res)) {
            project.name = prevName; // 실패했는데 화면만 바뀐 것처럼 보이지 않게
            if (res?.status !== 401) alert.showAlert(failMsg(res, "이름을 바꾸지 못했습니다."));
            return;
          }
          const i = projects?.findIndex((p: Project) => p.id === project.id);
          projects && i !== undefined && i >= 0 && (projects[i] = _.cloneDeep(project));
          setProjects(_.cloneDeep(projects));
        }
      }
    );
  };

  const handleClickEditInfo = async (event: any, el: Project) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedProjectId(el.id);
    setEditConfirmOpen(true);
  };

  const toggleFavorite = async (event: any, project: Project) => {
    event.stopPropagation();
    event.preventDefault();
    const index = projects?.findIndex((p) => p.id === project.id);
    if (index !== undefined) {
      const res = await dupLogin.checkDupLogin(() =>
        api.toggleFavoriteProject(project.id, project.isFavorite ? false : true)
      );
      if (!isOk(res)) {
        if (res?.status !== 401) alert.showAlert(failMsg(res, "즐겨찾기를 바꾸지 못했습니다."));
        return;
      }
      project.isFavorite = project.isFavorite ? false : true;
      setProjects(_.cloneDeep(projects));
      alert.showAlert(
        project.isFavorite
          ? "즐겨찾기에 추가되었습니다."
          : "즐겨찾기에서 삭제되었습니다."
      );
    }
  };

  const onSaveWorkList = async (type: number, object: any) => {
    if (type == 1) {
      if (object.deputyId) {
        await api.putDeputy(object, object.deputyId);
        setIsWorkModalModifyState(false);
        setIsWorkModalState(true);
      } else {
        await api.postDeputy(object);
        setIsWorkModalModifyState(false);
        setIsWorkModalState(true);
      }
    } else {
      if (object.company_id) {
        await api.putWorkCompany(object, object.company_id);
        setIsWorkModalModifyState(false);
        setIsWorkModalState(true);
      } else {
        await api.postWorkCompany(object);
        setIsWorkModalModifyState(false);
        setIsWorkModalState(true);
      }
    }
  };
  const onClickRemoveCancel = () => {
    setRemoveConfirmOpen(false);
  };

  const onClickRemoveConfirm = async () => {
    setRemoveConfirmOpen(false);
    const res = await dupLogin.checkDupLogin(() => api.deleteProject(selectedProjectId));
    if (!isOk(res)) {
      if (res?.status !== 401) alert.showAlert(failMsg(res, "프로젝트를 삭제하지 못했습니다."));
      return;
    }
    await getProjects();
  };

  /** 되물음(자료집)에도 '그래도 프로젝트로 열기' — 보관된 파일(토큰)로 다시 올리지 않고 변환한다 */
  const openAsProjectAnyway = async (ask: ImportAsk) => {
    setImportAsk(null);
    const busy = startBusy("파일을 콘엑스 형식으로 바꾸는 중입니다");
    try {
      const str = await api.convertEstimationToConax({ uploadToken: ask.uploadToken }, { force: true });
      await loadFromConaxFile(str, busy);
      busy.done();
      alert.showAlert(
        `불러오기를 마쳤습니다.\n목록 맨 위에서 '${ask.fileName.replace(/\.[^.]+$/, "")}' 프로젝트를 확인하세요.\n\n내역서는 비어 있고 일위대가·단가는 들어 있습니다.`
      );
    } catch (error: any) {
      busy.done();
      if (error?.refused?.reason === "token_expired") alert.showAlert(error.message);
      else if (error?.message !== DUP_LOGIN) alert.showAlert(error?.message || "파일을 불러오지 못했습니다. 파일을 다시한번 확인해 주세요.");
    } finally {
      busy.done();
    }
  };

  /** 되물음 → '단가집으로 올리기': 보관된 파일로 미리보기(담길 개수·내 단가집 목록)를 받아 창을 연다 */
  const startLibraryImport = async (ask: ImportAsk) => {
    setImportAsk(null);
    const busy = startBusy("단가집에 담을 품목을 읽는 중입니다");
    try {
      const preview = await api.importToMyLibrary({ uploadToken: ask.uploadToken, mode: "preview" });
      busy.done();
      const libs: any[] = preview?.libraries || [];
      setLibDlg({
        uploadToken: ask.uploadToken,
        fileName: ask.fileName,
        preview,
        name: (preview?.name || ask.fileName.replace(/\.[^.]+$/, "")).slice(0, 100),
        target: "new",
        libraryId: libs[0]?.id || "",
      });
    } catch (error: any) {
      busy.done();
      alert.showAlert(error?.message || "단가집에 담을 품목을 읽지 못했습니다.");
    } finally {
      busy.done();
    }
  };

  const saveLibrary = async () => {
    if (!libDlg || libSaving) return;
    const d = libDlg;
    if (d.target === "new" && !d.name.trim()) {
      alert.showAlert("단가집 이름을 입력해 주세요.");
      return;
    }
    setLibSaving(true);
    const busy = startBusy("단가집에 올리는 중입니다");
    try {
      const res = await api.importToMyLibrary({
        uploadToken: d.uploadToken,
        mode: "save",
        name: d.target === "new" ? d.name.trim() : undefined,
        libraryId: d.target === "existing" ? d.libraryId : undefined,
      });
      busy.done();
      const lib = res?.library || {};
      const ver = res?.version || {};
      const c = ver.counts || {};
      const lines: string[] = [];
      if (res?.unchanged) {
        lines.push(`'${lib.name}' 단가집에 이미 올린 내용과 같아 바꾼 게 없어요.`);
      } else {
        lines.push(
          (ver.v > 1 ? `'${lib.name}' 단가집을 새 파일 내용으로 갱신했습니다.` : `'${lib.name}' 단가집에 올렸습니다.`) +
            `\n${countsLine(c) || "담긴 품목 없음"}`
        );
        const df = ver.diff;
        if (ver.v > 1 && df) {
          lines.push(`이전 내용과 비교: 단가 변경 ${df.changed || 0} · 신규 ${df.new || 0} · 빠짐 ${df.removed || 0}`);
          lines.push("이전 내용도 남아 있어 되돌릴 수 있어요.");
        }
      }
      lines.push("\n쓰는 곳: 프로젝트를 연 뒤 위쪽 '나의 데이터' → '단가집'에서 품목을 찾아 내역에 넣을 수 있습니다.");
      setLibDlg(null);
      alert.showAlert(lines.join("\n"));
    } catch (error: any) {
      busy.done();
      alert.showAlert(error?.message || "단가집에 올리지 못했습니다.");
    } finally {
      setLibSaving(false);
      busy.done();
    }
  };

  const changeFile = async (event: any) => {
    const file = event.target.files?.[0];
    event.target.value = ""; // 같은 파일을 다시 고를 수 있게
    if (!file) return;
    if (/\.(sgs|est|estx|ebs|kdbx|xct|asgs)$/i.test(file.name)) {
      // 나스 SGS / 다산 EST / 글로텍 EBS / 이지테크 KDBX / 하우코스트 XCT / 아성 ASGS: 서버가 .conax 형식으로 변환 → 기존 .conax 불러오기와 같은 경로
      // (EMS·STmate 엑셀 .xlsx 는 서버 해석기가 있으나 닫아 둠 — 서버 XLSX_IMPORT_ENABLED)
      const busy = startBusy(`파일을 올리는 중입니다 (${mb(file.size)})`);
      try {
        let str: string;
        try {
          str = await api.convertEstimationToConax(file, {
            onUploadProgress: (pct) =>
              busy.stage(
                pct < 100
                  ? `파일을 올리는 중입니다 ${pct}% (${mb(file.size)})`
                  : `파일을 콘엑스 형식으로 바꾸는 중입니다 (${mb(file.size)})`
              ),
          });
        } catch (error: any) {
          if (error?.refused) {
            // 서버가 되물음: 자료집이거나 너무 큼 — 알림 대신 선택지를 준다(단가집으로 올리기 / 그래도 열기)
            busy.done();
            setImportAsk({ ...error.refused, fileName: error.refused.fileName || file.name });
            return;
          }
          let msg = error?.response
            ? "파일을 변환하지 못했습니다. 파일을 다시한번 확인해 주세요."
            : "서버와 연결이 끊겨 변환하지 못했습니다. 잠시 뒤 다시 시도해 주세요.";
          try {
            msg = JSON.parse(error?.response?.data).message || msg;
          } catch (e) {}
          throw new Error(msg);
        }
        await loadFromConaxFile(str, busy);
        busy.done();
        alert.showAlert(`불러오기를 마쳤습니다.\n목록 맨 위에서 '${file.name.replace(/\.[^.]+$/, "")}' 프로젝트를 확인하세요.`);
      } catch (error: any) {
        busy.done();
        if (error?.message !== DUP_LOGIN) alert.showAlert(error?.message || "파일을 불러오지 못했습니다. 파일을 다시한번 확인해 주세요.");
      } finally {
        busy.done();
      }
      return;
    }
    const busy = startBusy(`파일을 읽는 중입니다 (${mb(file.size)})`);
    const fileReader: FileReader = new FileReader();
    fileReader.onerror = () => {
      busy.done();
      alert.showAlert("파일을 읽지 못했습니다. 파일을 다시한번 확인해 주세요.");
    };
    fileReader.onload = async () => {
      try {
        const str = fileReader.result as string;
        await loadFromConaxFile(str, busy);
        busy.done();
        alert.showAlert("불러오기를 마쳤습니다.\n목록 맨 위에서 확인하세요.");
      } catch (error: any) {
        busy.done();
        if (error?.message !== DUP_LOGIN) alert.showAlert(error?.message || "오류가 발생하였습니다. 파일을 다시한번 확인해 주세요.");
      }
    };
    fileReader.readAsText(file);
  };

  const handleLectureClick = () => {
    const typeLecturePair: any = {
      normal: "0/47",
      estimate: "0/34",
      copy: "0/41",
    };
    window.open(
      process.env.REACT_APP_URL + "lectureroom/" + typeLecturePair[type],
      "",
      "width=#, height=#"
    );
  };

  const handleConaxLectureClick = () => {
    // type
    //normal -> 7/21
    //copy -> 7/41
    //es -> 7/34
    history.push("/lectureroom/7/35");
    // window.open(
    //   process.env.REACT_APP_URL + "lectureroom/7/35",
    //   "",
    //   "width=#, height=#"
    // );
  };

  const handleXmlFileChange = (event: any) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    const busy = startBusy(`파일을 읽는 중입니다 (${mb(file.size)})`);
    const fileReader: FileReader = new FileReader();
    fileReader.onerror = () => {
      busy.done();
      alert.showAlert("파일을 읽지 못했습니다. 파일을 다시한번 확인해 주세요.");
    };
    fileReader.onload = async () => {
      try {
        let str = fileReader.result as string;
        const res: any = str.match("비고>(.*?)</비고");
        const projectId = res?.[1];
        if (!projectId) throw new Error("콘엑스에서 내보낸 XML 파일이 아닙니다. 파일을 다시한번 확인해 주세요.");
        busy.stage("원본 프로젝트를 찾는 중입니다");
        let conaxString: string;
        try {
          const xmlRes = await api.getXmlProject(projectId);
          conaxString = xmlRes.data.encrypted_code;
        } catch (e) {
          throw new Error("이 XML 의 원본 프로젝트를 찾지 못했습니다. 파일을 다시한번 확인해 주세요.");
        }
        if (!conaxString) throw new Error("이 XML 의 원본 프로젝트를 찾지 못했습니다. 파일을 다시한번 확인해 주세요.");
        await loadFromConaxFile(conaxString, busy);
        busy.done();
        alert.showAlert("불러오기를 마쳤습니다.\n목록 맨 위에서 확인하세요.");
      } catch (error: any) {
        busy.done();
        if (error?.message !== DUP_LOGIN) alert.showAlert(error?.message || "오류가 발생하였습니다. 파일을 다시한번 확인해 주세요.");
      }
    };
    fileReader.readAsText(file);
  };

  const loadFromConaxFile = async (str: string, busy?: { stage: (m: string) => void }) => {
    busy?.stage(`파일 내용을 푸는 중입니다 (${mb(str.length)})\n큰 파일은 이 동안 화면이 잠시 멈출 수 있습니다`);
    await paint();
    const key = str.substring(0, 5);
    const value = str.substring(5);
    let obj: any;
    try {
      obj = JSON.parse(crypto.AES.decrypt(value, key).toString(crypto.enc.Utf8));
    } catch (e) {
      throw new Error("파일 내용을 읽지 못했습니다. 콘엑스 프로젝트 파일이 맞는지 확인해 주세요.");
    }
    if (!Array.isArray(obj)) throw new Error("파일 내용을 읽지 못했습니다. 콘엑스 프로젝트 파일이 맞는지 확인해 주세요.");
    const estimate = obj.filter((element: any) => element.type === "estimate");
    const copy = obj.filter((element: any) => element.type === "copy");
    const normal = obj.filter((element: any) => element.type === "normal");
    const contract = obj.filter((element: any) => element.type === "contract");
    const change = obj.filter((element: any) => element.type === "change");
    const ready = obj.filter((element: any) => element.type === "ready");
    const complete = obj.filter((element: any) => element.type === "complete");
    busy?.stage("서버로 보내는 중입니다");
    let res: any;
    try {
      res = await api.uploadProject(
        { copy, normal, contract, change, ready, complete, estimate },
        (pct) => busy?.stage(pct < 100 ? `서버로 보내는 중입니다 ${pct}%` : "서버에서 프로젝트를 만드는 중입니다")
      );
    } catch (error: any) {
      if (error?.response?.status === 401) {
        // 다른 곳에서 로그인해 세션이 끊김 — 기존 중복 로그인 안내를 그대로 띄운다
        await dupLogin.checkDupLogin(() => Promise.reject(error));
        throw new Error(DUP_LOGIN);
      }
      if (!error?.response) throw new Error("서버와 연결이 끊겨 저장하지 못했습니다.\n파일이 매우 크면 시간이 오래 걸리다 끊길 수 있습니다. 잠시 뒤 다시 시도해 주세요.");
      if (error.response.status === 413) throw new Error("파일이 너무 커서 저장하지 못했습니다.");
      throw new Error(error.response?.data?.message || `서버에서 저장하지 못했습니다 (오류 ${error.response.status}).`);
    }
    if (res?.data?.code !== 1) {
      throw new Error(res?.data?.message ? `저장하지 못했습니다: ${res.data.message}` : "서버에서 저장하지 못했습니다.");
    }
    busy?.stage("목록을 새로 고치는 중입니다");
    await getProjects();
  };

  const title = () => {
    if (lastpath === "normal") {
      return "나의 설계내역";
    } else if (lastpath === "estimate") {
      return "나의 견적서";
    } else if (lastpath === "custom_estimate") {
      return "나의 커스텀 견적서";
    } else if (lastpath === "worklist") {
      return "나의 계약서류";
    } else {
      return "나의 입찰내역";
    }
  };

  const elements = () => {
    if (lastpath === "worklist") {
      return workProjects?.map((el: any, index) => {
        return (
          <div
            className="board-card-list"
            onClick={() => {
              history.push(
                `/worklists/${el.worklist_id}/documents/companyinfo`
              );
            }}
          >
            <a>
              <div className="d-flex gap-5 align-items-center">
                <div className="date">
                  <span className="yy-mm">
                    {new Date(el.created).format("yy.MM")}
                  </span>
                  <div className="dd">{new Date(el.created).format("dd")}</div>
                </div>
                <div>
                  <div className="d-flex gap-2">
                    <div className="badge text-bg-primary-soft category mt-0">
                      {el.type === 'custom_estimate' ? '커스텀' : el.template === '건축' ? '건축' : '일반'}
                    </div>
                    {el.contract ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        계약
                      </div>
                    ) : (
                      ""
                    )}
                    {el.change ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        변경
                      </div>
                    ) : (
                      ""
                    )}
                    {el.ready ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        기성
                      </div>
                    ) : (
                      ""
                    )}
                    {el.complete ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        준공
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="title">{el.constructionName || "-"}</div>
                </div>
                <div className="position-absolute end-0 d-flex gap-2 me-4">
                  <button
                    type="button"
                    className="btn btn-danger-soft"
                    onClick={(event) =>
                      handleWorklistDelete(event, el.worklist_id)
                    }
                  >
                    <span className="material-symbols-outlined">delete</span>
                    삭제
                  </button>
                </div>
              </div>
            </a>
          </div>
        );
      });
    } else {
      return projects?.map((el, index) => {
        return (
          <div
            className="board-card-list"
            onClick={() => {
              clickProject(el);
            }}
          >
            <a>
              <div className="d-flex gap-5 align-items-center">
                <div className="date">
                  <span className="yy-mm">
                    {new Date(el.created).format("yy.MM")}
                  </span>
                  <div className="dd">{new Date(el.created).format("dd")}</div>
                </div>
                <div>
                  <div className="d-flex gap-2">
                    <div className="badge text-bg-primary-soft category mt-0">
                      {el.type === 'custom_estimate' ? '커스텀' : el.template === '건축' ? '건축' : '일반'}
                    </div>
                    {el.contract ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        계약
                      </div>
                    ) : (
                      ""
                    )}
                    {el.change ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        변경
                      </div>
                    ) : (
                      ""
                    )}
                    {el.ready ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        기성
                      </div>
                    ) : (
                      ""
                    )}
                    {el.complete ? (
                      <div className="badge text-bg-primary-soft category mt-0">
                        준공
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="title">{el.name}</div>
                </div>
                <div className="position-absolute end-0 d-flex gap-2 me-4">
                  <button
                    type="button"
                    className="btn btn-primary-soft"
                    data-bs-toggle="modal"
                    data-bs-target="#project-editModal"
                    onClick={(event) => handleClickEditInfo(event, el)}
                  >
                    <span className="material-symbols-outlined">edit</span>
                    수정
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger-soft"
                    data-bs-toggle="modal"
                    data-bs-target="#dialogs"
                    onClick={(event) => clickRemove(event, el)}
                  >
                    <span className="material-symbols-outlined">delete</span>
                    삭제
                  </button>
                  {type === "normal" && (
                    <button
                      type="button"
                      className={`btn btn-link p-0 ${styles.favoriteButton}`}
                      onClick={(event) => toggleFavorite(event, el)}
                    >
                      {
                        <svg
                          className={`${styles.starIcon} ${
                            el.isFavorite ? styles.filled : styles.outline
                          }`}
                          xmlns="http://www.w3.org/2000/svg"
                          width="36"
                          height="36"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      }
                    </button>
                  )}
                </div>
              </div>
            </a>
          </div>
        );
      });
    }
  };

  const clickRemove = (event: any, project: Project) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedProjectId(project.id);
    setRemoveConfirmOpen(true);
  };

  const totalCount = () => {
    if (lastpath === "worklist") {
      return workProjects.length;
    } else {
      return projects?.length;
    }
  };

  const types = [
    { title: "전체", value: "" },
    { title: "일반", value: "normal" },
    { title: "계약", value: "contract" },
    { title: "변경", value: "change" },
    { title: "기성", value: "ready" },
    { title: "준공", value: "complete" },
  ];

  return (
    <main id="wrap">
      <article>
        <section>
          <div className="container page">
            <div className="section-header">
              <div className="section-btn-right">
                <div className="d-flex align-items-center">
                  {title()}
                  {type !== "worklist" ? (
                    <a
                      className="btn text-gray-400"
                      onClick={handleLectureClick}
                    >
                      <span className="material-symbols-outlined">help</span>
                    </a>
                  ) : (
                    ""
                  )}
                </div>

                <div className="d-flex align-items-center gap-3">
                  <input
                    type="file"
                    onChange={changeFile}
                    style={{ width: 0, height: 0, position: "absolute", opacity: 0 }}
                    id="otherFile"
                    accept=".sgs,.SGS,.est,.EST,.estx,.ESTX,.ebs,.EBS,.kdbx,.KDBX,.xct,.XCT,.asgs,.ASGS"
                  />
                  <input
                    type="file"
                    onChange={changeConvertFile}
                    style={{ width: 0, height: 0, position: "absolute", opacity: 0 }}
                    id="convertFile"
                    accept=".sgs,.SGS,.est,.EST,.estx,.ESTX,.ebs,.EBS,.kdbx,.KDBX,.xct,.XCT,.asgs,.ASGS,.zip"
                  />
                  {type === "normal" ? (
                    <>
                      {!isExpiredUser.current && (
                        <div style={{ position: "relative" }}>
                          <button
                            type="button"
                            className="btn btn-outline-primary left-icon"
                            onClick={() => setShowTutorialChoice((v) => !v)}
                            disabled={tutorialLoading}
                          >
                            {tutorialLoading ? (
                              <CircularProgress size={16} style={{ color: "inherit", marginRight: 8 }} />
                            ) : (
                              <span className="material-symbols-outlined me-2">school</span>
                            )}
                            {tutorialLoading ? "준비 중..." : "튜토리얼 시작"}
                          </button>
                          {showTutorialChoice && !tutorialLoading && (
                            <div style={{
                              position: "absolute", top: "100%", left: 0, zIndex: 1000,
                              marginTop: 4, background: "#fff", borderRadius: 8,
                              boxShadow: "0 4px 16px rgba(0,0,0,0.15)", padding: 12,
                              display: "flex", flexDirection: "column", gap: 6, minWidth: 200,
                            }}>
                              <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => startTutorial("일반")}
                              >
                                일반 구조
                                <small style={{ display: "block", fontWeight: 400, fontSize: 11 }}>
                                  토목 / 조경 / 설비 등 (공사 → 공종 → 품명)
                                </small>
                              </button>
                              <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => startTutorial("건축")}
                              >
                                건축 구조
                                <small style={{ display: "block", fontWeight: 400, fontSize: 11 }}>
                                  건축공사 (공사 → 품명)
                                </small>
                              </button>
                              <button
                                className="btn btn-light btn-sm"
                                onClick={() => setShowTutorialChoice(false)}
                              >
                                취소
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                      <label
                        htmlFor="formFile"
                        className=" btn btn-light left-icon"
                        onClick={() => {
                          clickFile();
                        }}
                      >
                        <input
                          type="file"
                          onChange={changeFile}
                          style={{ width: 0, height: 0, position: "absolute" }}
                          id="conaxFile"
                          accept=".ddusul,.conax"
                        />
                        <span className="material-symbols-outlined me-2">
                          folder_open
                        </span>
                        .conax 파일열기
                      </label>
                      {otherProgramButton}
                      <button
                        type="button"
                        className="btn btn-primary left-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#project-editModal"
                        onClick={createProject}
                      >
                        <span className="material-symbols-outlined me-2">
                          add
                        </span>
                        설계내역 만들기
                      </button>
                      {/* 드물게 쓰는 기능은 ⋮ 메뉴 안에 */}
                      <div ref={moreRef} style={{ position: "relative" }}>
                        <input
                          type="file"
                          onChange={handleXmlFileChange}
                          style={{ width: 0, height: 0, position: "absolute", opacity: 0 }}
                          id="xmlFile"
                          accept=".xml"
                        />
                        <button
                          type="button"
                          className="btn text-gray-500 px-1"
                          aria-label="더보기"
                          title="더보기"
                          onClick={() => setMoreOpen((v) => !v)}
                        >
                          <span className="material-symbols-outlined">more_vert</span>
                        </button>
                        {moreOpen && (
                          <div
                            style={{
                              position: "absolute", top: "100%", right: 0, zIndex: 1000, marginTop: 4,
                              background: "#fff", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                              padding: 6, minWidth: 170,
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-light btn-sm w-100 text-start d-flex align-items-center"
                              onClick={() => {
                                setMoreOpen(false);
                                clickImportXmlFile();
                              }}
                            >
                              <span className="material-symbols-outlined me-2" style={{ fontSize: 18 }}>folder_open</span>
                              .xml 파일열기
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  ) : type === "estimate" ? (
                    <>
                      <label
                        htmlFor="formFile"
                        className=" btn btn-light left-icon"
                        onClick={() => {
                          clickFile();
                        }}
                      >
                        <input
                          type="file"
                          onChange={changeFile}
                          style={{ width: 0, height: 0, position: "absolute" }}
                          id="conaxFile"
                          accept=".ddusul,.conax"
                        />
                        <span className="material-symbols-outlined me-2">
                          folder_open
                        </span>
                        .conax 파일열기
                      </label>
                      {otherProgramButton}
                      <button
                        type="button"
                        className="btn btn-primary left-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#newprojectModal"
                        onClick={createEstimateProject}
                      >
                        <span className="material-symbols-outlined me-2">
                          add
                        </span>
                        견적서 만들기
                      </button>
                    </>
                  ) : type === "custom_estimate" ? (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary left-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#newprojectModal"
                        onClick={createEstimateProject}
                      >
                        <span className="material-symbols-outlined me-2">
                          add
                        </span>
                        커스텀 견적서 만들기
                      </button>
                    </>
                  ) : type === "worklist" ? (
                    <>
                      <button
                        type="button"
                        className="btn btn-light left-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#AgentModal"
                        onClick={() => {
                          showWorkListModal("1");
                        }}
                      >
                        <span className="material-symbols-outlined">
                          person_pin_circle
                        </span>
                        현장대리인
                      </button>
                      <button
                        type="button"
                        className="btn btn-light left-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#AgentModal"
                        onClick={() => {
                          showWorkListModal("2");
                        }}
                      >
                        <span className="material-symbols-outlined">
                          apartment
                        </span>
                        업체정보
                      </button>
                      <Link
                        to={pages.newwork}
                        className="btn btn-primary left-icon"
                      >
                        <span className="material-symbols-outlined me-2">
                          add
                        </span>
                        계약서류 만들기
                      </Link>
                    </>
                  ) : (
                    <>
                      <label
                        htmlFor="formFile"
                        className=" btn btn-light left-icon"
                        onClick={() => {
                          clickFile();
                        }}
                      >
                        <input
                          type="file"
                          onChange={changeFile}
                          style={{ width: 0, height: 0, position: "absolute" }}
                          id="conaxFile"
                          accept=".ddusul,.conax"
                        />
                        <span className="material-symbols-outlined me-2">
                          folder_open
                        </span>
                        .conax 파일열기
                      </label>
                      {otherProgramButton}
                      <button
                        type="button"
                        className="btn btn-primary left-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#newprojectModal"
                        onClick={createCopyProject}
                      >
                        <span className="material-symbols-outlined me-2">
                          add
                        </span>
                        입찰내역 만들기
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 pt-4">
              <div className="input-group mb-3" id="search-form">
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="검색어를 입력해주세요"
                  aria-label="Text input with dropdown button "
                  value={searchValue}
                  onChange={(e) => {
                    search(e.target.value, searchFilterValue);
                  }}
                />
              </div>
            </div>
            {!["worklist", "estimate", "custom_estimate"].includes(type) && (
              <div className="col-12 pt-5">
                <div className="category-wrap">
                  {types.map((type, index) => {
                    return (
                      <>
                        <input
                          type="radio"
                          className="btn-check"
                          name="category"
                          id={"option" + index}
                          checked={searchFilterValue == type.value}
                          value={type.value}
                          onChange={(e) => {
                            setSearchFilterValue(e.target.value);
                            search(searchValue, e.target.value);
                          }}
                        />
                        <label className="btn" htmlFor={"option" + index}>
                          {type.title}
                        </label>
                      </>
                    );
                  })}
                </div>
              </div>
            )}
            <div className="col-12">
              <div className="mt-5">
                <div>
                  TOTAL
                  <span className="text-primary fw-bold ms-1">
                    {totalCount()}
                  </span>
                </div>
              </div>
              <div
                className="board-list-wrap aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {elements()}
              </div>
            </div>
          </div>
        </section>
      </article>
      <Dialog open={otherOpen} onClose={() => setOtherOpen(false)} maxWidth="xs" fullWidth>
        <div style={{ padding: "22px 24px 20px" }}>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div style={{ fontSize: 17, fontWeight: 700 }}>타 프로그램 파일</div>
            <button type="button" className="btn text-gray-500 p-0" aria-label="닫기" onClick={() => setOtherOpen(false)}>
              <span className="material-symbols-outlined">close</span>
            </button>
          </div>
          <div style={{ background: "#f5f7fa", borderRadius: 8, padding: "12px 14px", fontSize: 13, lineHeight: 1.7, marginBottom: 16 }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>불러올 수 있는 파일</div>
            <div>· .sgs</div>
            <div>· .est · .estx (여러 파일 묶은 .zip)</div>
            <div>· .ebs</div>
            <div>· .kdbx</div>
            <div>· .xct</div>
            <div>· .asgs</div>
          </div>
          <div className="d-flex flex-column gap-2">
            <button
              type="button"
              className="btn btn-primary text-start d-flex align-items-center"
              style={{ padding: "12px 14px" }}
              onClick={() => {
                setOtherOpen(false);
                clickOtherImport();
              }}
            >
              <span className="material-symbols-outlined me-3">folder_open</span>
              <span>
                <span style={{ display: "block", fontWeight: 600 }}>불러오기</span>
                <small style={{ opacity: 0.85 }}>내 프로젝트로 만들어 바로 편집합니다</small>
              </span>
            </button>
            <button
              type="button"
              className="btn btn-light text-start d-flex align-items-center"
              style={{ padding: "12px 14px" }}
              onClick={() => {
                setOtherOpen(false);
                clickConvertFile();
              }}
            >
              <span className="material-symbols-outlined me-3">table_view</span>
              <span>
                <span style={{ display: "block", fontWeight: 600 }}>엑셀 변환</span>
                <small className="text-gray-500">프로젝트를 만들지 않고 콘엑스 양식 엑셀만 내려받습니다 (단가집은 1~2분)</small>
              </span>
            </button>
          </div>
        </div>
      </Dialog>
      {/* 서버가 되물은 경우: 수량 없는 자료집 / 46MB 초과 — 알림 한 줄로 끝내지 않고 다음 길을 같은 창에서 준다 */}
      <Dialog open={!!importAsk} onClose={() => setImportAsk(null)} maxWidth="xs" fullWidth>
        {importAsk && (
          <div style={{ padding: "22px 24px 20px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div style={{ fontSize: 17, fontWeight: 700 }}>
                {importAsk.reason === "too_large" ? "파일이 너무 커서 프로젝트로 열 수 없어요" : "수량이 없는 단가 자료예요"}
              </div>
              <button type="button" className="btn text-gray-500 p-0" aria-label="닫기" onClick={() => setImportAsk(null)}>
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            <div style={{ background: "#f5f7fa", borderRadius: 8, padding: "12px 14px", fontSize: 13, lineHeight: 1.7, marginBottom: 14 }}>
              <div style={{ fontWeight: 600, wordBreak: "break-all" }}>{importAsk.fileName}</div>
              {countsLine(importAsk.counts) && <div className="text-gray-600">{countsLine(importAsk.counts)}</div>}
            </div>
            <div style={{ fontSize: 13.5, lineHeight: 1.75, marginBottom: 16 }}>
              {importAsk.reason === "no_quantity" && (
                <>
                  수량이 입력된 내역 품목이 없어요. 프로젝트로 열면 <b>내역서가 비어 있고</b> 일위대가·단가만 들어가요.
                  <br />
                  <b>단가집으로 올리면</b> 다른 프로젝트에서 필요한 품목만 골라 쓸 수 있어요.
                </>
              )}
              {importAsk.reason === "too_large" && !importAsk.hasQuantity && (
                <>
                  변환 결과가 {importAsk.limitMb || 46}MB를 넘어 한 프로젝트로 저장할 수 없어요.
                  <br />
                  이 파일은 수량이 없는 단가 자료라서 <b>단가집으로 올리면</b> 그대로 쓸 수 있어요.
                </>
              )}
              {importAsk.reason === "too_large" && importAsk.hasQuantity && (
                <>
                  변환 결과가 {importAsk.limitMb || 46}MB를 넘어 한 프로젝트로 저장할 수 없어요.
                  <br />
                  원본 프로그램에서 <b>공사를 나눠 저장</b>한 뒤 각각 올려 주세요. 단가·일위대가만 필요하면 단가집으로 올릴 수 있어요.
                </>
              )}
            </div>
            <div className="d-grid gap-2">
              <button type="button" className="btn btn-primary" onClick={() => startLibraryImport(importAsk)}>
                단가집으로 올리기{importAsk.reason === "no_quantity" || !importAsk.hasQuantity ? " (추천)" : ""}
              </button>
              {importAsk.reason === "no_quantity" && (
                <button type="button" className="btn btn-outline-secondary" onClick={() => openAsProjectAnyway(importAsk)}>
                  그래도 프로젝트로 열기
                </button>
              )}
              <button type="button" className="btn btn-light" onClick={() => setImportAsk(null)}>
                취소
              </button>
            </div>
          </div>
        )}
      </Dialog>
      <Dialog open={!!libDlg && !libSaving} onClose={() => !libSaving && setLibDlg(null)} maxWidth="xs" fullWidth>
        {libDlg && (
          <div style={{ padding: "22px 24px 20px" }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div style={{ fontSize: 17, fontWeight: 700 }}>단가집으로 올리기</div>
              <button type="button" className="btn text-gray-500 p-0" aria-label="닫기" disabled={libSaving} onClick={() => setLibDlg(null)}>
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            <div style={{ background: "#f5f7fa", borderRadius: 8, padding: "12px 14px", fontSize: 13, lineHeight: 1.7, marginBottom: 14 }}>
              <div style={{ fontWeight: 600, wordBreak: "break-all" }}>{libDlg.fileName}</div>
              <div className="text-gray-600">담길 품목: {countsLine(libDlg.preview?.counts) || "없음"}</div>
              {(libDlg.preview?.dropped_wrappers || 0) > 0 && (
                <div className="text-gray-600">
                  일위대가 {Number(libDlg.preview.dropped_wrappers).toLocaleString()}개는 자재 하나만 감싼 포장이라 자재로 담겨요
                </div>
              )}
              {Array.isArray(libDlg.preview?.labors) && libDlg.preview.labors.length > 0 && (
                <div className="text-gray-600">
                  노임 {libDlg.preview.labors.length}종 중 {libDlg.preview.labors.filter((l: any) => l?.conaxLaborId).length}종은 콘엑스 노임과 연결돼 적용 연도를 따라가요
                </div>
              )}
            </div>
            {Array.isArray(libDlg.preview?.libraries) && libDlg.preview.libraries.length > 0 && (
              <div className="d-flex gap-3 mb-2" style={{ fontSize: 13.5 }}>
                <label className="d-flex align-items-center gap-1">
                  <input type="radio" name="libTarget" checked={libDlg.target === "new"} onChange={() => setLibDlg({ ...libDlg, target: "new" })} /> 새 단가집 만들기
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input type="radio" name="libTarget" checked={libDlg.target === "existing"} onChange={() => setLibDlg({ ...libDlg, target: "existing" })} /> 기존 단가집 갱신하기
                </label>
              </div>
            )}
            {libDlg.target === "new" ? (
              <div className="mb-3">
                <div style={{ fontSize: 12.5, marginBottom: 4 }}>단가집 이름</div>
                <input
                  className="form-control"
                  value={libDlg.name}
                  maxLength={100}
                  placeholder="예: 2026년 6월 공통자재"
                  onChange={(e) => setLibDlg({ ...libDlg, name: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && saveLibrary()}
                />
              </div>
            ) : (
              <div className="mb-3">
                <div style={{ fontSize: 12.5, marginBottom: 4 }}>단가집</div>
                <select className="form-select" value={libDlg.libraryId} onChange={(e) => setLibDlg({ ...libDlg, libraryId: e.target.value })}>
                  {libDlg.preview.libraries.map((l: any) => (
                    <option key={l.id} value={l.id}>
                      {l.name} · {l.updated ? String(l.updated).slice(5, 10) + " 올림" : "올림"}
                    </option>
                  ))}
                </select>
                <div className="text-gray-600" style={{ fontSize: 12, marginTop: 4 }}>같은 품명·규격·단위끼리 비교해 단가가 바뀐 것·새로 생긴 것·빠진 것을 알려 드려요. 이전 내용도 남아 있어 되돌릴 수 있고, 바뀐 게 없으면 그대로 둬요.</div>
              </div>
            )}
            <div style={{ fontSize: 12.5, color: "#666", marginBottom: 14 }}>단가집은 내 계정에서만 보이고, 데이터베이스에 품목을 만들지 않아요.</div>
            <div className="d-grid gap-2">
              <button type="button" className="btn btn-primary" disabled={libSaving} onClick={saveLibrary}>
                {libSaving ? "올리는 중…" : "올리기"}
              </button>
              <button type="button" className="btn btn-light" disabled={libSaving} onClick={() => setLibDlg(null)}>
                취소
              </button>
            </div>
          </div>
        )}
      </Dialog>
      <CreateProjectModal
        open={createOpen}
        onClose={createClose}
        estimate={estimate}
        copy={copy}
        tempRow={tempRow}
      />
      <WorkListModal
        type={isModalType}
        open={isWorkModalState}
        onClickCancel={() => {
          setIsWorkModalState(false);
        }}
        onClickWrite={(item?) => {
          setModifyState(item);
        }}
      />
      <DeleteConfirm
        open={removeConfirmOpen}
        onClickConfirm={onClickRemoveConfirm}
        onClickCancel={onClickRemoveCancel}
      />
      <EditProject
        isCreate={createOpen}
        open={editConfirmOpen}
        onClose={async (project) => {
          setEditConfirmOpen(false);
          setSelectedProjectId(0);
          if (createOpen) {
            setCreateOpen(false);
            if (project) {
              if (!project?.name) {
                alert.showAlert("프로젝트 이름을 입력해주세요.");
                return;
              }
              const busy = startBusy("프로젝트를 만드는 중입니다");
              try {
                const res: any = await api.createProject(
                  project.name,
                  false,
                  undefined,
                  undefined,
                  project.corporationType,
                  project.memo,
                  project.template
                );
                if (!isOk(res)) throw new Error(failMsg(res, "프로젝트를 만들지 못했습니다."));
                // 프로젝트 추가
                await getProjects();
              } catch (error: any) {
                alert.showAlert(error?.response ? failMsg(error.response, "프로젝트를 만들지 못했습니다.") : (error?.message || "프로젝트를 만들지 못했습니다."));
              } finally {
                busy.done();
              }
            }
            setSelectedProjectId(0);
          } else {
            if (project) {
              // 프로젝트 정보 수정 — 서버가 받아준 뒤에만 화면을 바꾼다(실패를 화면 갱신으로 감추지 않기)
              const res = await dupLogin.checkDupLogin(() => api.editProjectInfo(project));
              if (!isOk(res)) {
                if (res?.status !== 401) alert.showAlert(failMsg(res, "프로젝트 정보를 저장하지 못했습니다."));
                await getProjects(); // 모달에서 바뀐 값을 서버 값으로 되돌린다
                return;
              }
              const i = projects?.findIndex(
                (p: Project) => p.id === project.id
              );
              projects &&
                i !== undefined &&
                (projects[i] = _.cloneDeep(project));

              setProjects(_.cloneDeep(projects));
            }
          }
        }}
        project={projects?.find((p) => p.id === selectedProjectId)}
      />
    </main>
  );
};
